const countdownClock = () => {
  const MS = {
    DAY: 86_400_000,
    HOUR: 3_600_000,
    MINUTE: 60_000,
    SECOND: 1_000,
  };

  return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    interval: null,
    targetTime: null,
    showSeconds: false,
    controller: new AbortController(),

    init() {
      // Preload and calculate values immediately to avoid flash
      const settings = this.getSettings();
      if (!settings) {
        return;
      }

      this.targetTime = this.getTargetTimestamp(settings);
      this.showSeconds = settings.showSeconds === "true";

      // Calculate and set initial values immediately
      this.updateDisplay();

      // Start the timer for live updates
      this.startTimer();
    },

    setPlaceholderValues() {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    },

    getSettings() {
      const el = this.$el.closest("[data-countdown-settings]");
      try {
        return el ? JSON.parse(el.dataset.countdownSettings) : null;
      } catch {
        return null;
      }
    },

    getTargetTimestamp(settings) {
      const hour = this.to24Hour(settings);
      const { month, day, minute, seconds } = settings;
      const year = new Date().getFullYear();

      const target = new Date(
        `${year}-${month}-${day}T${hour}:${minute}:${seconds}`
      );

      // If target has passed, return current time to show 00:00:00
      return target < new Date() ? Date.now() - 1000 : target.getTime();
    },

    to24Hour({ timeFormat, hour12, hour24, ampm }) {
      if (timeFormat === "24h") return hour24;

      const h = +hour12;
      if (ampm === "AM") return h === 12 ? "00" : hour12.padStart(2, "0");
      return h === 12 ? "12" : String(h + 12);
    },

    startTimer() {
      const interval = this.showSeconds ? 1_000 : 60_000;

      this.interval = setInterval(() => {
        if (!document.hidden) this.updateDisplay();
      }, interval);

      document.addEventListener("visibilitychange", this.onVisibilityChange, {
        signal: this.controller.signal,
      });
    },

    onVisibilityChange() {
      if (document.hidden) {
        clearInterval(this.interval);
        this.interval = null;
      } else if (!this.interval) {
        this.updateDisplay();
        this.startTimer();
      }
    },

    updateDisplay() {
      const diff = this.targetTime - Date.now();

      if (diff <= 0) {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        this.stop();
        return;
      }

      this.days = Math.floor(diff / MS.DAY);
      this.hours = Math.floor((diff % MS.DAY) / MS.HOUR);
      this.minutes = Math.floor((diff % MS.HOUR) / MS.MINUTE);
      this.seconds = Math.floor((diff % MS.MINUTE) / MS.SECOND);
    },

    stop() {
      clearInterval(this.interval);
      this.interval = null;
    },

    destroy() {
      this.stop();
      this.controller.abort();
    },
  };
};

window.countdownClock = countdownClock;
export default countdownClock;
